<template>
  <div style="display:inline-block;margin:0 10px">
    <el-button size="small" type="success" @click="showDialog">创建客户订单</el-button>
    <el-dialog title="创建客户订单" :visible.sync="dialogVisible" width="1200px">
      <el-form :inline="true" ref="addForm" :model="addForm">
        <el-form-item label="客户名称:" prop="customer_name">
          <el-input
            size="small"
            :value="addForm.customer_name"
            :disabled="true"
            style="width:200px"
          ></el-input>
        </el-form-item>
        <el-form-item label="订单号:" prop="order_number">
          <el-input size="small" v-model="addForm.order_number" style="width:200px"></el-input>
        </el-form-item>
        <el-form-item label="下单日期:" prop="order_date">
          <el-date-picker
            size="small"
            v-model="addForm.order_date"
            type="date"
            placeholder="选择日期"
            style="width:200px"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <el-input size="small" v-model="addForm.remark" style="width:200px"></el-input>
        </el-form-item>
        <el-table :data="addForm.productList" :border="true" show-summary>
          <el-table-column align="center" prop="product_name" label="产品名称"></el-table-column>
          <el-table-column align="center" prop="product_size" label="产品规格"></el-table-column>
          <el-table-column align="center" label="库存数">
            <template slot-scope="scope">
              <div>{{scope.row.stock_number}}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="product_price" label="单价" width="150px">
            <template slot-scope="scope">
              <el-form-item
                :prop="`productList.${scope.$index}.price`"
                :rules="{ pattern: /^[0-9]*(\.[0-9]{1,2})?$/, message: '请输入数字(最多两位小数)', trigger: 'blur' }"
              >
                <el-input size="small" v-model="scope.row.price"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="product_count" label="数量" width="150px">
            <template slot-scope="scope">
              <el-form-item
                :prop="`productList.${scope.$index}.count`"
                :rules="{ pattern: /^\d*$/, message: '请输入数字', trigger: 'blur' }"
              >
                <el-input size="small" v-model="scope.row.count"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="money" label="金额" width="150px">
            <template slot-scope="scope">
              <el-form-item
                :prop="`productList.${scope.$index}.money`"
                :rules="{ pattern: /^[0-9]*(\.[0-9]{1,2})?$/, message: '请输入数字(最多两位小数)', trigger: 'blur' }"
              >
                <el-input size="small" :value="scope.row.money" :disabled="true"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="cost_hour" label="所需工时" width="150px">
            <template slot-scope="scope">
              <el-form-item
                :prop="`productList.${scope.$index}.cost_hour`"
                :rules="{ pattern: /^[0-9]*(\.[0-9]{1,2})?$/, message: '请输入数字(最多两位小数)', trigger: 'blur' }"
              >
                <el-input size="small" :value="scope.row.cost_hour" :disabled="true"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column align="center" label="交付日期" width="215px">
            <template slot="header" slot-scope="scope">
              <span>交付日期 </span>
              <el-date-picker
                size="small"
                v-model="quickDeliveredDate"
                type="date"
                placeholder="统一设置"
                style="width:130px;display:inline-block"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
              <span style="display:hidden">{{scope.row}}</span>
            </template>
            <template slot-scope="scope">
              <el-form-item
                :prop="`productList.${scope.$index}.delivered_date`"
                :rules="{ pattern: /^[^p]/, message: '请输入正确的日期', trigger: 'blur' }"
              >
                <el-date-picker
                  size="small"
                  v-model="scope.row.delivered_date"
                  type="date"
                  placeholder="选择日期"
                  style="width:150px"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="dialogVisible=false">取消</el-button>
        <el-button size="small" :disabled="buttonDisable" type="primary" @click="addCustomerOrder">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { addCustomerOrder } from '../api/index'
export default {
  props: ['selectList'],
  data () {
    return {
      dialogVisible: false,
      buttonDisable: false,
      spanArr: [],
      quickDeliveredDate: '',
      addForm: {
        customer_name: '',
        order_number: '',
        order_date: '',
        remark: '',
        productList: []
      }
    }
  },
  watch: {
    selectList: {
      handler (selectList) {
        this.addForm.productList = selectList.map(item => {
          return {
            product_name: item.product_name,
            product_size: item.product_size,
            stock_number: item.stock_number,
            price: item.product_price,
            total_hour: item.total_hour,
            count: '',
            money: '',
            cost_hour: '',
            delivered_date: ''
          }
        })
      }
    },
    'addForm.productList': {
      handler (productList) {
        productList.forEach(item => {
          if (item.count === '' || item.price === '' || item.price === null) {
            item.money = ''
          } else {
            item.money = (item.count * (item.price * 100) / 100).toFixed(2)
          }
          if (item.count === '' || item.total_hour === '' || item.total_hour === null) {
            item.cost_hour = ''
          } else {
            item.cost_hour = (item.count * (item.total_hour * 100) / 100).toFixed(2)
          }
        })
      },
      deep: true
    },
    quickDeliveredDate (date) {
      this.addForm.productList.forEach(item => {
        item.delivered_date = date
      })
    }
  },
  methods: {
    showDialog () {
      if (this.selectList.length === 0) {
        this.$message.error('请至少选择一个产品')
        return
      }
      this.addForm.customer_name = this.selectList[0].customer_name
      let isSame = true
      this.selectList.forEach(item => {
        item.customer_name !== this.addForm.customer_name && (isSame = false)
      })
      if (isSame) {
        this.dialogVisible = true
      } else {
        this.$message.error('请选择相同客户的产品创建订单')
      }
    },
    addCustomerOrder () {
      // let params = JSON.parse(JSON.stringify(this.addForm))
      this.buttonDisable = true
      addCustomerOrder(this.addForm).then(res => {
        this.buttonDisable = false
        if (res.status === 200) {
          this.$message.success('添加成功')
          this.dialogVisible = false
        }
      })
    }
  }
}
</script>

<style>
</style>
